export default "__VITE_ASSET__wU4FtAkA__"